import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Transforms the resources_minification criteria from WooRank API response
 * into the shape expected by the React report UI.
 *
 * @param {Object} resourcesMinificationCriteria - criteria.resources_minification
 * @returns {Object} transformed criteria
 */
export const transformResourcesMinification = (resourcesMinificationCriteria) => {
  // If missing, treat as empty/success for parity with legacy view (which shows "Perfect...")
  if (!resourcesMinificationCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'Perfect, all your assets are minified.',
      data: null,
    };
  }

  const wooRankStatus = resourcesMinificationCriteria?.status || 'neutral';
  const importance = resourcesMinificationCriteria?.importance || 0;
  const solvability = resourcesMinificationCriteria?.solvability || 0;

  const unminifiedResources = resourcesMinificationCriteria?.data?.unminifiedResources || [];

  const rows = unminifiedResources
    .map((r) => {
      const url = r?.url || '';
      const sizeBefore = Number(r?.sizeBefore || 0);
      const sizeAfter = Number(r?.sizeAfter || 0);
      const bytesSaved = Math.max(0, sizeBefore - sizeAfter);
      const percentSaved = sizeBefore > 0 ? (bytesSaved / sizeBefore) * 100 : 0;

      return { url, bytesSaved, percentSaved, sizeBefore };
    })
    .filter((r) => Boolean(r.url));

  const totalBefore = rows.reduce((sum, r) => sum + (Number(r.sizeBefore) || 0), 0);
  const totalSaved = rows.reduce((sum, r) => sum + (Number(r.bytesSaved) || 0), 0);
  const totalPercent = totalBefore > 0 ? (totalSaved / totalBefore) * 100 : 0;

  const isEmpty = rows.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: isEmpty ? 'Perfect, all your assets are minified.' : null,
    data: isEmpty
      ? null
      : {
          rows: rows.map(({ url, bytesSaved, percentSaved }) => ({ url, bytesSaved, percentSaved })),
          totals: { totalBefore, totalSaved, totalPercent },
        },
  };
};

export default transformResourcesMinification;


